export default __webpack_public_path__ + "static/media/LadoDerecho.674885b3.jpg";